import axios from 'axios';
import { SystemErrorLogInputDTO } from '@haohan/papi-dto';

export const systemApi = {
	async logError(input: SystemErrorLogInputDTO) {
		await axios.post<any>(
			'/api/system/error/log/', input
		);
	},
}
